












import { Component, Vue, Mixins } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'

import { SET_SELECTED } from '@/system/store/action-types'
import { IActionType } from '@/system/store'
import { GET_SELECTED_PROJECTS } from '@/system/store/getter-types'
import { IProjectStore } from '@/features/projectList/store'
import { projectListLocalisationKeys } from '@/features/projectList/projectList.localisation'
import SearchPanel from '@/features/projectList/components/SearchPanel.vue'
import ProjectListHeader from '@/features/projectList/components/ProjectListHeader.vue'
import ProjectList from '@/features/projectList/components/ProjectList.vue'
import NextButton from '@/shared/NextButton.component.vue'
import Notification from '@/shared/Notification.mixin.vue'
import WatchOnJob from '@/shared/WatchOnJob.mixin.vue'

@Component({
  components: {
    SearchPanel,
    ProjectListHeader,
    ProjectList,
    NextButton
  }
})
export default class ProjectListView extends Mixins(
  Notification,
  WatchOnJob
) {
  private translations = projectListLocalisationKeys
  private unwatch: any

  @Getter(GET_SELECTED_PROJECTS)
  selectedProjects!: IProjectStore[]
  @Action(SET_SELECTED)
  setSelected!: IActionType

  protected created (): void {
    this.unwatch = this.watchOnValidationFailedStatus()
  }

  protected destroyed (): void {
    this.unwatch()
  }

  get getDisable () {
    return Boolean(!this.selectedProjects.length)
  }
}

